module.exports = __webpack_public_path__ + "static/media/rush_bookmark_groucho_back1_2x.da2cf725.jpg";